// extracted by mini-css-extract-plugin
export default {"cls1":"UserAvatar-cls1_qXW","cls2":"UserAvatar-cls2_TCC UserAvatar-cls1_qXW"};